export default class CardResponse {
    constructor (json) {
        this._cards = json.retailerCards
    }

    cards () {
        return this._cards
    }
}



// WEBPACK FOOTER //
// ./src/models/responses/CardResponse.js